import React from "react";
import { Play, Lock } from "lucide-react";
import { money } from "@/lib/format";
import { BudgetBar, PlatformPill, EndingSoon, PosterBox } from "@/components/brand";

export default function CampaignCard({ campaign, onOpen }) {
  const c = campaign;
  const enabled = c.platforms?.filter((p) => p.enabled) || [];
  return (
    <div
      onClick={() => onOpen(c)} data-testid={`campaign-card-${c.slug}`}
      className="surface fade-up focus-ring"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onOpen(c)}
      style={{ borderRadius: 12, overflow: "hidden", cursor: "pointer", transition: "border-color .18s", display: "flex", flexDirection: "column" }}
    >
      <PosterBox poster={c.posters?.card} alt={c.title} rounded={0} style={{ aspectRatio: "16 / 9", width: "100%" }}>
        {!c.posters?.card && (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Play size={26} color="rgba(255,255,255,.5)" />
          </div>
        )}
        {c.locked && (
          <div style={{ position: "absolute", top: 8, right: 8 }}><span className="chip"><Lock size={12} /> Private</span></div>
        )}
      </PosterBox>
      <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 10, flex: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.title}</div>
            <div style={{ fontSize: 12, color: "var(--muted)" }}>{c.brand_name}</div>
          </div>
          {c.ending_soon && <EndingSoon />}
        </div>
        <div style={{ fontSize: 18, fontWeight: 500, color: "var(--text)" }}>{money(c.top_rate)} <span style={{ fontSize: 12, color: "var(--sub)" }}>per 1K views</span></div>
        <BudgetBar used={c.budget_used} total={c.budget_total} />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {enabled.map((p) => <PlatformPill key={p.platform} platform={p.platform} label={p.label} />)}
        </div>
        <button className="btn-brand focus-ring" onClick={(e) => { e.stopPropagation(); onOpen(c); }} data-testid={`card-join-${c.slug}`} style={{ padding: "9px 14px", fontSize: 13, marginTop: "auto" }}>
          {c.budget_exhausted ? "Budget exhausted" : "Join"}
        </button>
      </div>
    </div>
  );
}
